import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from "../components/Menu";

const Header = () => {
  const navRef = useRef(null);

  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 150) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  // let x = ["navbar"];
  // if (scrolled) {
  //   x.push("scrolled");
  // }

  return (
    <nav
      ref={navRef}
      className={`d-flex align-items-center container header ${
        scrolled ? "scrolled" : ""
      }`}>
      <div className="logo">
        <Link className="text-white font-weight-bolder" to="/">
          wedevelopers
        </Link>
      </div>
      <Menu />
    </nav>
  );
};

export default Header;
